import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CorePopupComponent } from '../../../../../../../ui-components/core-popup/core-popup.component';
import { ParameterService } from '../../../../../../../shared/services/parameter/parameter.service';
import { Option } from '../../../../../../../ui-components/core-dropdown/core-dropdown.component';
import { AppMessageService } from '../../../../../../../shared/services/app-message/app-message.service';
import { CaseService } from '../../../../../services/case.services';
import { combineLatest, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  selectCaseId,
  selectRecordType,
} from '../../../../../store/selectors/common-case.selector';
import {
  setAppointmentStatus,
  setCancelInformations,
  setCaseStatus,
} from '../../../../../store/actions/common-case.actions';
import {
  CaseRecordTypeEnum,
  CaseStatusesEnum,
} from '../../../../../interfaces/interfaces';

@Component({
  selector: 'app-case-cancel',
  templateUrl: './case-cancel.component.html',
  styleUrl: './case-cancel.component.scss',
})
export class CaseCancelComponent implements OnInit, OnDestroy {
  @ViewChild('corePopup') popup: CorePopupComponent;
  showPopup: boolean = false;
  selectedReason: number | null = null;
  cancelDescription: string = '';
  cancelReasons: Option[] = [];
  caseId: number | null;
  recordType: CaseRecordTypeEnum | null;
  private subscription!: Subscription;

  constructor(
    private readonly parameterService: ParameterService,
    private readonly messageService: AppMessageService,
    private readonly caseService: CaseService,
    private readonly store: Store
  ) {}

  ngOnInit() {
    this.subscription = combineLatest([
      this.store.select(selectCaseId),
      this.store.select(selectRecordType),
    ]).subscribe({
      next: ([caseId, recordType]) => {
        this.caseId = caseId ?? null;
        this.recordType = recordType ?? null;
      },
    });
  }

  initilize(recordType: CaseRecordTypeEnum, caseCancelInformations: any) {
    this.cancelDescription = caseCancelInformations.cancelDescription ?? '';
    this.selectedReason = caseCancelInformations.cancelReason;
    this.parameterService
      .getParameterValues(
        'case-parameters',
        recordType === CaseRecordTypeEnum.case
          ? 'case-cancel-reasons'
          : 'appointment-cancel-reasons'
      )
      .subscribe({
        next: (res) => {
          this.cancelReasons =
            res?.datas?.values?.map((data: any) => {
              return {
                label: data?.valueObject?.name?.value,
                value: data?.valueObject?.id?.value,
                disabled: !data?.valueObject?.status?.value,
              };
            }) ?? [];
          this.showPopup = true;
          this.popup.openDialog();
        },
      });
  }

  get currentLength(): number {
    return (this.cancelDescription || '').length;
  }

  save() {
    if (!this.selectedReason) {
      this.messageService.errorToast('', 'İptal Nedeni Zorunlu');
      return;
    }

    this.caseService
      .cancelCase({
        cancelDescription: this.cancelDescription,
        cancelReason: this.selectedReason,
        caseId: this.caseId!,
      })
      .subscribe({
        next: (res) => {
          if (res.isSuccess) {
            if (this.recordType === CaseRecordTypeEnum.case) {
              this.store.dispatch(
                setCaseStatus({ status: CaseStatusesEnum.canceled })
              );
            } else if (this.recordType === CaseRecordTypeEnum.appointment) {
              this.store.dispatch(
                setAppointmentStatus({ status: CaseStatusesEnum.canceled })
              );
            }

            this.store.dispatch(
              setCancelInformations({
                cancelDescription: this.cancelDescription,
                cancelReason: this.selectedReason!,
              })
            );

            this.popup.closeDialog();
            this.messageService.successToast('Başarılı', 'Kayıt iptal edildi');
          }
        },
      });
  }

  onHide() {}

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    this.unSub();
  }

  unSub() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngOnDestroy(): void {
    this.unSub();
  }
}
